<script setup lang="ts">
import { getSurenetUrl } from '@menu-lib/urlHelper';
import VColumn from '@shared/component/VDataTable/VColumn.vue';
import VDataTable from '@shared/component/VDataTable/VDataTable.vue';
import { useRowLinkNavigation } from '@shared/component/VDataTable/useRowLinkNavigation';
import VSkeleton from '@shared/component/VSkeleton/VSkeleton.vue';

export type Item = {
  Status: string;
  Offertenummer: string;
  DetailsUrl: string;
  TijdstipFormatted: string;
};

defineProps<{
  loading: boolean;
  items?: Array<Item>;
}>();

const { onRowClicked } = useRowLinkNavigation({
  rowLink: (row: any) => getSurenetUrl(row.DetailsUrl, false),
});
</script>

<template>
  <VSkeleton height="lg" :count="6" v-if="loading" />

  <VDataTable
    v-else-if="items?.length"
    show-row-arrow
    @row-click="onRowClicked"
    :value="items"
    :loading
  >
    <VColumn sortable header="Nummer" field="Offertenummer">
      <template #body="{ data }">
        {{ data.Offertenummer }}
      </template>
    </VColumn>
    <VColumn header="Status" field="Status">
      <template #body="{ data }">
        {{ data.Status }}
      </template>
    </VColumn>
    <VColumn header="Aangemaakt op" field="Tijdstip">
      <template #body="{ data }">
        {{ data.TijdstipFormatted }}
      </template>
    </VColumn>
  </VDataTable>
</template>
